import React, { useState, useEffect } from "react";
import "../../styles/styles.css";
import logo from "../../assets/logo/logo.png";
import call from "../../assets/icons/phone.svg";
// import { ReactComponent as Logo } from '../../assets/logo/logo.svg'
import { ReactComponent as Logo } from '../../assets/logo/gozowo.svg'

const Navbar = () => {
  const navList = [
    { name: "Partners", href: "/partners" },
    { name: "Investors", href: "/investors" },
    { name: "Business", href: "/business" },
    { name: "Careers", href: "/careers" },
    { name: "Safety", href: "/safety" },
  ];
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const splitText = (text) => {
    return text.split("").map((letter, index) => (
      <span
        key={index}
        className="letter"
        style={{ "--char-index": index }}
        aria-hidden="true" // for accessibility
      >
        {letter === " " ? "\u00A0" : letter}
      </span>
    ));
  };
  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };


  return (
    <>
      <nav className="navbar">
        <div className="navbar-logo">
          <a href="/">
            {/* <img className="logo" alt="logo" src={logo} /> */}
            <Logo></Logo>
          </a>
        </div>
        <ul className="navbar-links desktop-nav">
          {navList.map((nav, index) => (
            <li key={index} className="navbar-item">
              <a href={nav.href}>{splitText(nav.name)}</a>
            </li>
          ))}
        </ul>
        <button className="hamburger-button" onClick={toggleMobileMenu}>
          <span className="hamburger-icon">&#9776;</span>
        </button>
        <button className="lets-talk-button">
          <img className="call" alt="call" src={call} />
          Let's Talk
        </button>
      </nav>
      <ul
        className={`navbar-links mobile-nav ${isMobileMenuOpen ? "show" : ""}`}
      >
        {navList.map((nav, index) => (
          <li key={index} className="navbar-item">
            <a href={nav.href}>{splitText(nav.name)}</a>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Navbar;
